import React from 'react';
import {
	QuickLinkAsset,
	QuickLinkEmail,
	QuickLinkExternal,
	QuickLinkInternal,
	StyledQuickLinks,
} from '../../../ui';

const pdfLink =
	'http://assets.ctfassets.net/jaw4bomip9l3/6CqZiXsBnmc8oLRCLqcFEq/502a0431b0075184f0843295f840be71/hello-world.pdf';

const assetLink =
	'https://images.ctfassets.net/jaw4bomip9l3/1q5YQ4tkksUYuuioMkeowG/094f1dad9578d5249cb6e240c8df23de/23569861-sample-grunge-red-round-stamp.jpg';

export const QuickLinks = () => (
	<>
		<h2 id="quick-links">Quick links</h2>

		<h4>Quick links, 1 column</h4>
		<StyledQuickLinks columns={1}>
			<QuickLinkAsset title="Asset link" url="" />
			<QuickLinkInternal title="Internal link" url="/flights" />
		</StyledQuickLinks>

		<h4>Quick links, 2 columns on desktop</h4>
		<StyledQuickLinks columns={[2, { tablet: 1 }]}>
			<QuickLinkAsset title="PDF link" url={pdfLink} />
			<QuickLinkInternal title="Internal link" url="/flights" />
			<QuickLinkExternal title="Go to Google" url="https://www.google.com" />
			<QuickLinkEmail title="Email us" address="foo@example.com" />
			<QuickLinkAsset
				title="Asset link with a very very very very very very very very very very very very very very long title"
				url={assetLink}
			/>
		</StyledQuickLinks>
	</>
);
